import qs from 'query-string';

export const getObjectFromHref = (href) => {
  if (typeof href !== 'string' || !(href.indexOf('?') > 0)) {
    return null;
  }

  return qs.parse(href.slice(href.indexOf('?')));
};
